export default {
  schedule: {
    type: Object,
    required: true
  },
  professionalCurrent: {
    type: Object,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/consultations-made/resources/props.js